import { render, staticRenderFns } from "./RecuperacionPass.vue?vue&type=template&id=5b364196&scoped=true"
import script from "./RecuperacionPass.vue?vue&type=script&lang=js"
export * from "./RecuperacionPass.vue?vue&type=script&lang=js"
import style0 from "./RecuperacionPass.vue?vue&type=style&index=0&id=5b364196&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b364196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b364196')) {
      api.createRecord('5b364196', component.options)
    } else {
      api.reload('5b364196', component.options)
    }
    module.hot.accept("./RecuperacionPass.vue?vue&type=template&id=5b364196&scoped=true", function () {
      api.rerender('5b364196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recuperacion/RecuperacionPass.vue"
export default component.exports